//Permanent
const twitterAccount = "elcomercio_peru";    
const brand = "El Comercio";
const urlBrand = "https://elcomercio.pe/";
const urlPortadaEspeciales = "https://especiales.elcomercio.pe/?q=especiales/especiales-el-comercio/index.html";
const domainMarca = "https://especiales.elcomercio.pe/?q=especiales/";
const domainAssets = "https://d1ts5g4ys243sh.cloudfront.net/proyectos_especiales_prod/especiales/";
 
const amountOfCards = 20;
const socialShareText = "Te comparto una tarjeta por estas fiestas";
const title = "Tarjetas de Navidad y Año Nuevo 2022";
const slugCommonAssets = 'elementos-comunes/';
const slugCommonAssets2 = 'elementos-comunes-2/';
const urlCommonAssets = `${domainAssets}${slugCommonAssets}`;
const urlCommonAssets2 = `${domainAssets}${slugCommonAssets2}`;
const slugSpecial = 'tarjetas-de-navidad-y-ano-nuevo-2022-nndd-ecvisual-ecpm';
const urlEspecial = `${domainMarca}${slugSpecial}/index.html`;
const urlAssets = `${domainAssets}${slugSpecial}`;
const googleSheetKey = '13aJoU8TJrBoUoGB5jZRqm06kDZ9BpP7t4nmyGiIln0w';
const query = 'select%20C%2C%20D%2C%20E%20where%20B%20%3D%20';
const urlForm = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLScTuuMlUPiZYJc9nxQZVjvwiMP97HLyYzDKk6okREzhkOyCZA/formResponse';
const qryParam = '&';
const viewPostal = 'postal';
const viewCard = 'idTarjeta';

export { 
    amountOfCards,
    brand,
    googleSheetKey,
    query,
    qryParam, 
    socialShareText, 
    title, 
    twitterAccount, 
    urlAssets, 
    urlCommonAssets,
    urlCommonAssets2, 
    urlEspecial, 
    urlForm,
    urlBrand, 
    urlPortadaEspeciales, 
    viewPostal, 
    viewCard 
};